import { createScanSubmitTargetRegistry } from '../utils/createScanSubmitTargetRegistry.util';

export const SCAN_SUBMIT_TARGET_REGISTRY = createScanSubmitTargetRegistry();
